import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["CoherenceLinksProvider"] */ "/app/front_end/src/app/(main)/components/coherence_links_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/comments_feed_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/headers/community_header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/headers/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/histogram_drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/key_factors/key_factors_feed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/key_factors/key_factors_question_section.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/app/(main)/questions/[id]/components/key_factors/key-factors.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/notebook_redirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/post_score_data/disagreement_forecasts_chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_embed_button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_embed_modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_layout/consumer_question_layout/consumer_tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_layout/consumer_question_layout/responsive_comment_feed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuestionLayoutProvider"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_layout/question_layout_context.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/app/(main)/questions/[id]/components/question_variant_composer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_view/consumer_question_view/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_view/forecaster_question_view/question_header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/sidebar/sidebar_question_info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/sidebar/sidebar_question_projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/sidebar/similar_questions/similar_questions_drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoherenceLinks"] */ "/app/front_end/src/app/(main)/questions/components/coherence_links/coherence_links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/comment_feed/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/conditional_timeline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/consumer_post_card/group_forecast_card/numeric_forecast_card.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/detailed_question_card/detailed_group_card/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/detailed_question_card/detailed_question_card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/forecast_maker/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/markdown_editor/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostDropdownMenu"] */ "/app/front_end/src/components/post_actions/post_dropdown_menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SharePostMenu"] */ "/app/front_end/src/components/post_actions/share_post_menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/post_card/community_disclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/post_subscribe/subscribe_button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/question/private_note.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/question/score_card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/refresh_button.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/ui/expandable_content.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/ui/section_toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabsList","TabsTab","TabsSection"] */ "/app/front_end/src/components/ui/tabs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/contexts/cp_context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedModalContextProvider"] */ "/app/front_end/src/contexts/embed_modal_context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostSubscriptionProvider"] */ "/app/front_end/src/contexts/post_subscription_context.tsx");
